/* global PRODUCTION */
/* global DEVELOPMENT */
/* global STAGING */

/* @ngInject */
const paths = () => {
  const self = {}

  console.log('PRODUCTION', PRODUCTION, STAGING)

  self.api = PRODUCTION ?
    'https://sygem.digithia.com/api/' :
    STAGING ?
      'https://sygem-test.digithia.com/api/' :
      'http://localhost:3000/'

  self.excel_files = PRODUCTION ?
    'https://sygem.digithia.com/excel_files/' :
    STAGING ?
      'https://sygem-test.digithia.com/excel_files/' :
      'http://localhost:8000/excel_files/'

  self.handlers = {
    account: self.api + 'users',
    autocomplete: self.api + 'autocomplete',
    area: self.api + 'areas',
    railway: self.api + 'railways',
    dispatch: self.api + 'dispatches',
    contact: self.api + 'contacts',
    email: self.api + 'emails',
    phone: self.api + 'phones',
    owner: self.api + 'owners',
    movement: self.api + 'movements',
    train: self.api + 'trains',
    wagon: self.api + 'wagons',
    sale: self.api + 'sales',
    axletree: self.api + 'axletrees',
    piece: self.api + 'pieces',
    sterile: self.api + 'steriles',
    setting: self.api + 'settings',
    commande: self.api + 'commandes',
  }

  return self
}

export default paths



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/resources/paths.resource.js